<script>
import Layout from "../../layouts/main"
import { common } from '@/mixins/common'
import PageHeader from "@/components/page-header";
import ShowList from "@/components/pages/liveShows/showList";
import AlbumList from "@/components/pages/liveShows/albumList";
import AddNewShowDrawerContent from "../../../components/drawers/product/AddNewShowDrawerContent.vue";
import AddNewAlbumDrawerContent from "../../../components/drawers/product/AddNewAlbumDrawerContent.vue";
import { GetApiActionWithAuthorizationOnly } from "../../../helpers/apiActions";

export default {
    page: {
        title: "Manage Live Show"
    },

    components: {
        Layout,
        PageHeader,
        AddNewAlbumDrawerContent,
        AddNewShowDrawerContent,
        ShowList,
        AlbumList
    },

    data() {
        return {
            title: "Live Shows",
            tabTitle: "",
            tabCount: 0,
            displayNewAlbumPopup: false,
            displayNewShowPopup: false,
            selectedShow: { id: 0},
            onPageTabLoad: true,
            selectedAlbum: { id: 0, title: '', AuctionAttachments: [] },
            liveShowAccounts: [],
            tabs: [
                {
                    value: 'Shows',
                    link: 'shows',
                    icon: 'fas fa-bolt fa-fw unchecked-icon',
                    active: false
                },
                {
                    value: 'Albums',
                    link: 'albums',
                    icon: 'fas fa-images',
                    active: false
                }
            ],
            tab: ""
        }
    },

    mixins: [
        common
    ],
    mounted() {
        const _vm = this
        _vm.tab = _vm.$route.query.tab || "shows";
        let findActiveTabIndex = _vm.tabs.findIndex((m) => m.link == _vm.tab) || 0;
        _vm.$set(
            _vm.tabs,
            findActiveTabIndex,
            Object.assign(_vm.tabs[findActiveTabIndex], {
                active: true,
            })
        );
    },
    methods: {
        handleNewAlbum () {
            this.displayNewAlbumPopup = true
        },
        formatNumber (number) {
            return String(number).padStart(3, '0')
        },
        preventTabClick(tab, oldTab) {
            if (typeof oldTab === "string" && oldTab.length > 1) {
                location.href = "/products/live-show/index?tab=" + tab
            }
            return this.onPageTabLoad && (oldTab == 0 || !oldTab)
        },
        handleTabClick() {
            this.onPageTabLoad = false
            return this.onPageTabLoad
        },
        handleNewShow () {
            let _vm = this
            return GetApiActionWithAuthorizationOnly("admin/products/live-show/get-shows-data").then(res => {
                _vm.tabCount = res.data.showCount + 1
                _vm.liveShowAccounts = res.data.applications
                _vm.displayNewShowPopup = true
            });
        },
    },
    computed: {}
}
</script>

<template>
    <div class="product-listing-page">
        <el-drawer
            ref="addNewShowDrawer"
            :title="'NEW LIVE SHOW'"
            :visible.sync="displayNewShowPopup"
            :close-on-press-escape="false"
            :with-header="true"
            :wrapperClosable="false"
            :size="mediumDrawerSize"
            :append-to-body="true"
            :destroy-on-close="true"
            custom-class="common-drawer demo-drawer"
            >
            <AddNewShowDrawerContent
                :show="selectedShow"
                :count="tabCount"
                :liveShowAccounts="liveShowAccounts"/>
        </el-drawer>
        <el-drawer
            ref="addNewAlbumDrawer"
            :title="'New Album'"
            :visible.sync="displayNewAlbumPopup"
            :close-on-press-escape="false"
            :with-header="true"
            :wrapperClosable="false"
            :size="middleDrawerSize"
            :append-to-body="true"
            :destroy-on-close="true"
            custom-class="common-drawer demo-drawer"
            >
            <AddNewAlbumDrawerContent :album="selectedAlbum"/>
        </el-drawer>
        <Layout>
            <PageHeader
                :title="title"
                :subTitle="tabTitle"
                icon="fas fa-bolt fa-fw unchecked-icon" />
            <div class="auction-page-container">
                <div class="button-items mb-2">
                    <b-button
                        variant="success"
                        @click="handleNewShow()"
                        title="Start new live show">
                        <i class="fas fa-play-circle font-size-16"></i>&nbsp;
                        <span style="font-weight: 500;">BEGIN SHOW</span>
                    </b-button>
                    <b-button
                        variant="primary"
                        @click="handleNewAlbum()">
                        <i class="fas fa-image font-size-16"></i>&nbsp;
                        <span style="font-weight: 500;">NEW ALBUM</span>
                    </b-button>
                </div>
                <el-tabs
                    type="border-card"
                    v-model="tab"
                    :before-leave="preventTabClick"
                    @tab-click="handleTabClick">
                    <el-tab-pane
                      v-for="_tab in tabs"
                        :key="_tab.link"
                        :active="_tab.active"
                        :name="_tab.link"
                    >
                        <template #label>
                          <i :class="['font-size-16', _tab.icon]"></i> {{ _tab.value }}
                        </template>
                        <ShowList v-if="_tab.link === 'shows'"/>
                        <AlbumList v-if="_tab.link === 'albums'"/>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </Layout>
    </div>
</template>